import React, { useEffect, useRef } from 'react'

export default function FileInput({ accept, multiple, value, onChange, readFormat, ...props }) {
  const inputRef = useRef(null)

  useEffect(() => {
    if (!inputRef.current) return
    if (!multiple && !value) inputRef.current.value = null
    else if (multiple && !value?.length) inputRef.current.value = null
    else if (!multiple) {
      const inputValue = inputRef.current?.files?.[0]
      if (value != inputValue) {
        const dt = new DataTransfer()
        dt.items.add(value)
        inputRef.current.files = dt.files
      }
    } else {
      const inputValue = [...inputRef.current?.files]
      if (inputValue.length !== value.length || value.some((v, i) => v !== inputValue[i])) {
        const dt = new DataTransfer()
        for (const v of value) dt.items.add(v)
        inputRef.current.files = dt.files
      }
    }
  }, [value, inputRef.current])

  async function handleChange(e) {
    const target = e.currentTarget || e.target
    for (const file of target.files) {
      await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          let result = reader.result
          if (readFormat === 'base64') {
            const match = result.match(/^data:[\w-]+\/[\w.-]+;base64,([a-zA-Z0-9+/=]+)$/)
            console.log('in base64', match)
            if (!match) reject(new Error('Data is not in expected base64 format.'))
            else result = match[1]
          }
          file.fileContent = result
          resolve(file.fileContent)
        }
        reader.onerror = (err) => {
          reject(err)
        }
        switch (readFormat) {
          case 'base64':
            reader.readAsDataURL(file)
            break
          case 'text':
            reader.readAsText(file)
            break
          case 'arrayBuffer':
            reader.readAsArrayBuffer(file)
            break
          default:
            reject(new Error('No readFormat specified.', props, readFormat))
        }
      })
    }
    onChange({ [target.name]: multiple ? target.files : target.files?.[0] })
  }

  return <input {...props} ref={inputRef} type='file' accept={accept} multiple={multiple} onChange={handleChange} />
}
